import { useCallback, useMemo, useState } from 'react';
import useBrandActions from 'data/hooks/useBrandActions';
import { format, isToday } from 'date-fns';

import { BrandIntegration } from 'model/brand';

type Params = {
  brandId: string;
  integration: BrandIntegration;
  isChecked: boolean;
};

const useConnect = ({ brandId, integration, isChecked }: Params) => {
  const { unpause, updateState, isLoading } = useBrandActions();
  const [showBusyModeModal, setShowBusyModeModal] = useState<boolean>(false);

  const busyUntil = useMemo(() => {
    if (!integration.isBusy) {
      return null;
    }
    if (integration.busyUntil == null) {
      return 'indefinitely';
    }
    if (isToday(integration.busyUntil)) {
      return `Until ${format(integration.busyUntil, 'hh:mm aaa')}`;
    }
    return `Until ${format(integration.busyUntil, 'MM/dd/yyyy hh:mm aaa')}`;
  }, [integration]);

  const handleChangeStatus = useCallback(async () => {
    if (isChecked) {
      setShowBusyModeModal(true);
      // await pause({ brandId, integrationId });
    } else {
      await unpause({ brandId, integrationId: integration.id });
    }
  }, [unpause, brandId, integration, isChecked]);

  return {
    handleChangeStatus,
    isLoading,
    showBusyModeModal,
    setShowBusyModeModal,
    updateState,
    busyUntil,
  };
};

export default useConnect;
